import { render, staticRenderFns } from "./RatioFayankes.vue?vue&type=template&id=da25d23a&scoped=true&"
import script from "./RatioFayankes.vue?vue&type=script&lang=js&"
export * from "./RatioFayankes.vue?vue&type=script&lang=js&"
import style0 from "./RatioFayankes.vue?vue&type=style&index=0&id=da25d23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da25d23a",
  null
  
)

export default component.exports